import _ from 'lodash';
import React from 'react';
import { Col, Tab, Nav, NavItem } from 'react-bootstrap';
import DeviceInfo from 'containers/request/Initial/Steps/Vendor/DeviceInfo';
import PointOfContact from 'containers/request/Initial/Steps/Vendor/PointOfContact';
import Billing from 'containers/request/Initial/Steps/Vendor/Billing';
import LabInfo from 'containers/request/Initial/Steps/Vendor/LabInfo';
import Documents from 'containers/request/Initial/Steps/Vendor/Documents';
import DocumentsECO from 'containers/request/ECO/Steps/Vendor/Documents';
import LicenseAgreement from 'containers/request/Initial/Agreements/index';
import PaymentInfo from 'containers/request/Initial/PaymentInfo';
import CertificationOptions from 'containers/request/Initial/CertificationOptions';

export const vendorTabs = [
  // 0
  {
    key: 'deviceInfo',
    title: 'Device Info',
    component: DeviceInfo
  },
  // 1
  {
    key: 'poc',
    title: 'Point of Contact',
    component: PointOfContact
  },
  // 2
  {
    key: 'billing',
    title: 'Billing',
    component: Billing
  },
  // 3
  {
    key: 'labInfo',
    title: 'Lab Info',
    component: LabInfo
  },
  // 4
  {
    key: 'documents',
    title: 'Documents',
    component: Documents
  },
  // 5
  {
    key: 'documentsECO',
    title: 'Documents',
    component: DocumentsECO
  },
  // 6
  {
    key: 'agreement',
    title: 'License Agreement',
    component: LicenseAgreement
  },
  // 7
  {
    key: 'publication',
    title: 'Publication',
    component: CertificationOptions
  },
  // 8
  {
    key: 'invoice',
    title: 'Payment Info',
    component: PaymentInfo
  }
];

/**
 * Filter tabs with only expected as Initial request type.
 *
 * @param {object} request Request object
 * @returns array
 */
export const getVendorInitialTabs = request => {
  const tabs = _.pick(vendorTabs, [0, 1, 2, 3, 4, 6, 7, 8]);
  return filterVendorOptions(tabs, request);
};

/**
 * Filter tabs with only expected as ECO request type.
 *
 * @param {object} request Request object
 * @returns array
 */
export const getVendorECOTabs = request => {
  const tabs = _.pick(vendorTabs, [0, 1, 2, 3, 5, 8]);
  return filterVendorOptions(tabs, request);
};

const filterVendorOptions = (tabs, request) => {
  return _.filter(tabs, tab => {
    /* 
      Hide Billing and Payment tabs 
      if request has no billing info
    */
    if (tab.key === 'billing' || tab.key === 'invoice') {
      return request.hasBilling === true;
    }

    return true;
  });
};

/**
 * Render passed components inside nav tabs.
 *
 * @param {array} tabs Tab list
 * @returns JSX layout
 */
export const renderTabs = tabs => {
  return (
    <Col xs={12} sm={12} md={2}>
      <Nav bsStyle="pills" stacked>
        {tabs.map(tab => {
          return (
            <NavItem eventKey={tab.key} key={tab.key}>
              {tab.title}
            </NavItem>
          );
        })}
      </Nav>
    </Col>
  );
};

/**
 * Render all tabs' content.
 *
 * @param {array} tabs Tab list
 * @param {*} activeTab ID (key) for current active tab
 * @returns JSX layout
 */
export const renderTabsContent = (tabs, activeTab) => {
  return (
    <Col xs={12} sm={12} md={8}>
      <Tab.Content animation>
        {tabs.map(tab => {
          if (tab.key !== activeTab) return null;

          const TabContent = tab.component;
          return (
            <Tab.Pane eventKey={tab.key} key={tab.key}>
              <TabContent />
            </Tab.Pane>
          );
        })}
      </Tab.Content>
    </Col>
  );
};



// WEBPACK FOOTER //
// ./src/helpers/RequestTabsHelper.js